import { useEffect } from 'react';
import { useUserPreferences } from './useUserPreferences';
import { useWeek } from '../contexts/WeekContext';
import { useAuthUser } from '../contexts/AuthUserContext';

/**
 * Hook that automatically applies user's preferred default date range
 * to the WeekContext when the user preference changes or component mounts
 */
export const useDefaultDateRange = () => {
    const { getDefaultDateRangeDays } = useUserPreferences();
    const { setDefaultRangeFromPreference } = useWeek();
    const user = useAuthUser();

    useEffect(() => {
        // Only apply preferences when user is loaded to avoid race conditions
        if (user?.email) {
            const preferredDays = getDefaultDateRangeDays();
            // console.log('🔍 Applying user default date range:', preferredDays, 'days');
            setDefaultRangeFromPreference(preferredDays);
        }
    }, [user?.email, getDefaultDateRangeDays, setDefaultRangeFromPreference]);

    return {
        applyUserDefaultRange: () => {
            const preferredDays = getDefaultDateRangeDays();
            setDefaultRangeFromPreference(preferredDays);
        },
        getUserPreferredDays: getDefaultDateRangeDays
    };
}; 